import {
  SET_LOADER_STATE
} from "./loader.types";

const getInitialState = () => {
  return {
    isLoading: true
  };
};


const initialState = getInitialState();

const loader = (state = initialState, action) => {
  const types = {
    [SET_LOADER_STATE]: () => ({
      ...state,
      isLoading: action.loaderState
    })
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
}

export default loader;
